import React from 'react';
import {theme} from '../../../styles/darkTheme';
import {Container, Label, Value} from './styles';

interface Props {
  label?: string;
  value?: string;
  valueSize?: string;
  clear?: boolean;
  labelColor?: string;
  valueColor?: string;
}

const Card: React.FC<Props> = ({
  label,
  labelColor,
  value,
  valueColor,
  valueSize,
  clear,
}) => {
  return (
    <Container theme={theme} clear={clear}>
      <Label theme={theme} color={labelColor}>
        {label}
      </Label>
      <Value theme={theme} valueSize={valueSize} color={valueColor}>
        {value}
      </Value>
    </Container>
  );
};

export default Card;
